import RepairFileOriginTypeConstant from '@/constants/repair-module/repair-file/repairFileOriginTypeConstant'
import RepairFileEndStatusConstant from '@/constants/repair-module/repair-file/repairFileEndStatusConstant'

export function isReplacementEstimateOffer(offer) {
  const offerType = offer?.offer_type?.toUpperCase()
  return (
    offerType === RepairFileEndStatusConstant.PRODUCT_REPLACED_STANDARD ||
    offerType === RepairFileEndStatusConstant.PRODUCT_REPLACED_SUPERIOR
  )
}

export function getRepairFilePayload(repairFile) {
  return repairFile?.raw || repairFile
}

export function isKeyAccountRepairFile(repairFile) {
  return getRepairFilePayload(repairFile)?.origin_type === RepairFileOriginTypeConstant.KEY_ACCOUNT
}
